export function formatLocale(locale: string): string {
  return locale.replace(/_/g, '-').toLowerCase();
}